var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      ref: "profile_modal",
      attrs: {
        size: "xl",
        bodyClass: "p-0",
        "no-close-on-backdrop": true,
        "hide-header": true,
        dialogClass: _vm.dialog_class_draw,
      },
      scopedSlots: _vm._u([
        {
          key: "modal-header",
          fn: function ({ close }) {
            return [
              _c(
                "b-button",
                {
                  attrs: { size: "sm", variant: "outline-danger" },
                  on: {
                    click: function ($event) {
                      return close()
                    },
                  },
                },
                [_vm._v("\n            Close Modal\n        ")]
              ),
            ]
          },
        },
        {
          key: "modal-footer",
          fn: function ({ close }) {
            return [
              _c("div", { staticClass: "modal-footer w-100" }, [
                _c(
                  "button",
                  {
                    staticClass:
                      "btn btn-outline-danger waves-effect waves-themed mr-5",
                    attrs: { type: "button" },
                    on: { click: _vm.remove_item },
                  },
                  [_vm._v("\n                Видалити\n            ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass:
                      "btn btn-secondary waves-effect waves-themed ml-5",
                    attrs: { type: "button" },
                    on: { click: _vm.close_modal },
                  },
                  [_vm._v("\n                Закрити\n            ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-success waves-effect waves-themed",
                    attrs: { type: "button" },
                    on: { click: _vm.save_doc },
                  },
                  [_vm._v("\n                Зберегти\n            ")]
                ),
              ]),
            ]
          },
        },
      ]),
      model: {
        value: _vm.is_show_modal,
        callback: function ($$v) {
          _vm.is_show_modal = $$v
        },
        expression: "is_show_modal",
      },
    },
    [
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "panel mb-0 border-bottom-0 shadow-none",
          attrs: { id: "panel_users_list" },
        },
        [
          _c(
            "div",
            {
              staticClass:
                "panel-hdr border-faded border-top-0 border-right-0 border-left-0 shadow-0",
            },
            [
              _c("h2", [
                _c("span", { staticClass: "fw-300" }, [
                  _vm._v("ID:" + _vm._s(this.doc.id)),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "panel-toolbar pr-3 pb-2 align-self-end" },
                [
                  _c(
                    "button",
                    {
                      staticClass:
                        "btn btn-panel bg-transparent fs-xl w-auto h-auto rounded-0 waves-effect waves-themed",
                      on: {
                        click: function ($event) {
                          return _vm.close()
                        },
                      },
                    },
                    [_c("i", { staticClass: "fal fa-times" })]
                  ),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          !_vm.is_load
            ? _c("div", { staticClass: "p-1" }, [
                _c(
                  "div",
                  { staticClass: "template p-3" },
                  [
                    _c("users_select", {
                      attrs: { active_id: parseInt(_vm.doc.user_id) },
                      on: { on_item_set: _vm.set_user_id },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "template p-3" },
                  [
                    _c("organization_select", {
                      attrs: {
                        label: "Організація власник",
                        active_id: parseInt(_vm.doc.tov_id),
                      },
                      on: { on_organization_set: _vm.set_tov_id },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "template p-3" },
                  [
                    _c("equipment_type_select", {
                      attrs: { active_id: parseInt(_vm.doc.type_id) },
                      on: { on_item_set: _vm.set_type_id },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "template p-3" }, [
                  _c(
                    "label",
                    {
                      staticClass: "form-label",
                      attrs: { for: "payment_online" },
                    },
                    [
                      _vm._v(
                        "\n                    Характеристики\n                "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "select_step" },
                    [
                      _c("b-textarea", {
                        attrs: { rows: 5 },
                        model: {
                          value: _vm.doc.description,
                          callback: function ($$v) {
                            _vm.$set(_vm.doc, "description", $$v)
                          },
                          expression: "doc.description",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "template p-3" }, [
                  _c(
                    "label",
                    {
                      staticClass: "form-label",
                      attrs: { for: "payment_online" },
                    },
                    [
                      _vm._v(
                        "\n                    Інвентарний номер\n                "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "select_step" },
                    [
                      _c("b-input", {
                        model: {
                          value: _vm.doc.number,
                          callback: function ($$v) {
                            _vm.$set(_vm.doc, "number", $$v)
                          },
                          expression: "doc.number",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "template p-3" }, [
                  _c(
                    "label",
                    {
                      staticClass: "form-label",
                      attrs: { for: "payment_online" },
                    },
                    [_vm._v("\n                    Ціна\n                ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "select_step" },
                    [
                      _c("b-input", {
                        model: {
                          value: _vm.doc.price,
                          callback: function ($$v) {
                            _vm.$set(_vm.doc, "price", $$v)
                          },
                          expression: "doc.price",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "template p-3" }, [
                  _c(
                    "label",
                    {
                      staticClass: "form-label",
                      attrs: { for: "payment_online" },
                    },
                    [_vm._v("\n                    Коментар\n                ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "select_step" },
                    [
                      _c("b-textarea", {
                        attrs: { rows: 3 },
                        model: {
                          value: _vm.doc.comment,
                          callback: function ($$v) {
                            _vm.$set(_vm.doc, "comment", $$v)
                          },
                          expression: "doc.comment",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "template p-3" },
                  [
                    _c("users_admin_select", {
                      attrs: { active_id: parseInt(_vm.doc.init_user) },
                      on: { on_item_set: _vm.set_admin_user_id },
                    }),
                  ],
                  1
                ),
              ])
            : _vm._e(),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }